<template>
  <div>
    <v-alert v-if="creditError" type="error">Nedostatek kreditu</v-alert>
    <v-alert v-if="serverError" color="error">Chyba serveru.</v-alert>
    <v-container>
      <v-row>
        <v-col
          class=""
          cols="6"
        >
          <v-card
            class="mx-auto"
            max-width="344"
          >
            <v-card-text>
              <h2 class="heading text--primary">
                Fakturační údaje
              </h2><br>
              <div class="text--primary">
                <p>{{ cart.user ? cart.user.companyName : '' }}</p>
                <p>IČO: {{ cart.user ? cart.user.ico : '' }}</p>
                <p>DIČ: {{ cart.user ? cart.user.dic : '' }}</p>
                <!-- prazdne stringy, pokud neni zvoleny uzivatel - haze vue errory -->
                <p>{{ cart.user ? cart.user.fullName : '' }}</p>
                <p>{{ cart.user ? cart.user.street : '' }} {{ cart.user ? cart.user.streetNumber : '' }},
                  {{ cart.user ? cart.user.city : '' }} {{ cart.user ? cart.user.zip : '' }}</p>
                <p>{{ cart.user ? cart.user.email : '' }}</p>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="6"

        >
          <v-card
            class="mx-auto"
            max-width="344"
          >
            <v-card-text>
              <h2 class="heading text--primary">
                Dodací údaje
              </h2><br>
              <div class="text--primary">
                <p>{{ cart.user ? deliveryInfo.name : '' }}</p>
                <p>{{ cart.user ? deliveryInfo.street : '' }}
                  {{ cart.user ? deliveryInfo.streetNumber : '' }},
                  {{ cart.user ? deliveryInfo.city : '' }} {{ cart.user ? deliveryInfo.zip : '' }}</p>
                <p>{{ cart.user ? cart.user.email : '' }}</p>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        class="cart-4-step"
      >
        <v-col cols="4">
          <v-radio-group
            :disabled="!!orderObject.id /* && currentUser.roleId === 6 */"
            v-model="cart.customPackaging"
            mandatory
          >
            <v-radio :value="true" label="Vlastní nádoba"></v-radio>
            <v-radio :label="`Standardní balení ${totalPackagingPrice} Kč`" :value="false"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="4">
          <v-radio-group
            :disabled="!!orderObject.id /* && currentUser.roleId === 6 */"
            v-model="cart.deliveryType"
            mandatory
          >
            <v-radio v-if="cart.diet.dietType !== 'Instituční'" label="Osobní odběr" value="Osobní odběr"></v-radio>
            <v-radio :label="`Rozvoz ${totalDeliveryPrice} Kč`" value="Rozvoz"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col
          cols="4">
          <v-radio-group v-model="cart.paymentTypeId" :disabled="!!orderObject.id" mandatory>
            <v-radio v-if="cart.diet.dietType !== 'Instituční'" :value="3" label="Hotově/Kartou při převzetí">>
            </v-radio>
            <v-radio v-if="currentUser.roleId === 6" :value="5" label="Kartou online"></v-radio>
            <!-- label - prazdny string, pokud neni zvoleny uzivatel -->
            <v-radio
              :label="cart.user ? (cart.user.maxDebt ? 'Kredit/Dluh' : 'Kredit') : ''"
              :value="1"
            ></v-radio>
            <v-radio
              v-if="cart.user && cart.user.paymentTransfer"
              :value="4"
              label="Bankovním převodem"
            ></v-radio>
          </v-radio-group>
        </v-col>
        <v-col
          cols="12">
          <v-textarea
            v-model="cart.description"
            label="Doplňující info k objednávce"
            outlined
            rows="4">
          </v-textarea>
        </v-col>
      </v-row>
    </v-container>
    <div class="order-control-buttons text-right">
      <div v-if="$store.state.ordering.orderObject.id">Původní cena: {{ $store.state.ordering.orderObject.price }} Kč
      </div>
      <div>Celkem: {{ totalOrderPrice }} Kč</div>
      <v-btn text @click="cancelOrder">Zrušit</v-btn>
      <v-btn class="mr-2" color="secondary" outlined @click="goToStep(3)">Zpět</v-btn>
      <v-btn
        :disabled="cartEmpty || submitWait"
        :loading="submitWait"
        color="success"
        @click="finishOrder"
      >
        Dokončit objednávku
      </v-btn>
<!--      <span>{{this.$store.state.ordering.cart.user.preferredCustomPackaging}}</span>-->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Step4',
  data () {
    return {
      submitWait: false,
      creditError: false,
      serverError: false,
      finishOrderLoader: null
    }
  },
  methods: {
    cancelOrder () {
      this.reset()
      this.$emit('order-canceled')
    },
    finishOrder () {
      // check if order is payable
      if (this.cart.paymentTypeId === 1) {
        const user = this.cart.user

        if (this.orderObject.id) { // editace
          const orderDiff = this.totalOrderPrice - this.orderObject.price
          if (orderDiff > 0) {
            if (user.credit + user.maxDebt < orderDiff) {
              this.creditError = true
              return
            }
          }
        } else { // vytvareni
          if (user.credit + user.maxDebt < this.totalOrderPrice) {
            this.creditError = true
            return
          }
        }
      }

      this.submitWait = true
      const options = {
        method: this.orderObject.id ? 'put' : 'post',
        url: this.currentUser.roleId === 6 ? '/orders' : '/admin/orders',
        data: this.keysToSnakeCase({
          ...this.cart,
          order: !!this.cart.order,
          price: this.totalOrderPrice,
          userId: this.cart.user.id,
          dietId: this.cart.diet.id,
          items: { ...this.cart.items },
          editedDelivery: null
        })
      }
      options.url += this.orderObject.id ? '/' + this.orderObject.id : ''
      this.$http(options)
        .then(response => {
          if (this.cart.paymentTypeId === 5) {
            window.location.replace(response.data)
          }
          this.$emit('order-finished')
          this.reset()
          this.updateShoppingCartStorage()
          this.goToStep(5)
          this.submitWait = false
        })
        .catch(err => {
          if (this.cart.paymentTypeId === 1 && err.response.status === 400) {
            alert('Nedostatek kreditu.')
          } else {
            this.serverError = true
            // eslint-disable-next-line no-return-assign
            setTimeout(() => this.serverError = false, 3500)
          }
          this.submitWait = false
        })
    },
    ...mapMutations({
      updateCredit: 'user/updateCredit',
      goToStep: 'ordering/goToOrderingStep',
      reset: 'ordering/reset',
      updateShoppingCartStorage: 'ordering/updateShoppingCartStorage'
    })
  },
  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      cart: 'ordering/shoppingCart',
      deliveryInfo: 'ordering/deliveryInfo',
      cartEmpty: 'ordering/shoppingCartEmpty',
      totalOrderPrice: 'ordering/totalOrderPrice',
      totalDeliveryPrice: 'ordering/totalDeliveryPrice',
      totalItemsPrice: 'ordering/totalItemsPrice',
      totalPackagingPrice: 'ordering/totalPackagingPrice',
      step: 'ordering/step',
      orderObject: 'ordering/cartOrder'
    }),
    // vuex bindings
    'cart.description': {
      get () {
        return this.$store.ordering.state.cart.description
      },
      set (val) {
        this.$store.commit('ordering/setOrderDescription', val)
      }
    },
    'cart.deliveryType': {
      get () {
        return this.$store.ordering.state.cart.deliveryType
      },
      set (val) {
        this.$store.commit('ordering/setDeliveryType', val)
      }
    },
    'cart.customPackaging': {
      get () {
        return this.$store.ordering.state.cart.customPackaging
      },
      set (val) {
        this.$store.commit('ordering/setPackagingType', val)
      }
    }
  },
  watch: {
    'cart.paymentTypeId': function () {
      this.updateShoppingCartStorage()
    },
    'cart.deliveryType': function () {
      this.updateShoppingCartStorage()
    },
    'cart.customPackaging': function () {
      this.updateShoppingCartStorage()
    },
    creditError (val) {
      if (val) {
        setTimeout(() => {
          this.creditError = false
        }, 2500)
      }
    }
  },
  created () {
    if (this.cart.diet.dietType === 'Instituční' && this.cart.paymentTypeId === 3) {
      this.cart.paymentTypeId = 1
    }
  },
  mounted () {
    // if (this.$store.state.ordering.cart.user.preferredCustomPackaging === 0) {
    //   this.cart.customPackaging = false
    // }
  }
}
</script>

<style scoped>

</style>
